export default __webpack_public_path__ + "static/media/banner1.2368d6c0.png";